var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_WHATSAPP_NOTIFICATION_REQUEST, getWhatsappNotificationFailure, getWhatsappNotificationSuccess, } from "../../actions";
import API from "../../../utils/API";
const onGetWhatsappNotification = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const countryCode = "in";
        try {
            API.get(`notification/settings/${countryCode}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getWhatsappNotificationWorker(action) {
    try {
        const data = yield call(onGetWhatsappNotification, action);
        yield put(getWhatsappNotificationSuccess(data));
    }
    catch (error) {
        yield put(getWhatsappNotificationFailure(error));
    }
}
export function* watchGetWhatsappNotificationData() {
    yield takeLatest(GET_WHATSAPP_NOTIFICATION_REQUEST, getWhatsappNotificationWorker);
}
